import template from 'lodash/template';
import { _js } from '@ifixit/utils/localize';

class Template {
   constructor() {
      this.cachedTemplates = {};
   }

   #getCompiledTemplate(str) {
      const compiled = template(str);
      // lodash compiles to `with (obj) { … }`, so templates can only reach
      // their locals and true globals — never an importing module's scope.
      // Inject `_js` so templates can translate without a window global.
      return (data, asString) => {
         const html = compiled({ _js, ...data });
         return asString ? html : this.#htmlToDom(html);
      };
   }

   /**
    * Converts a string of HTML to a DOM element.
    *
    * Returns:
    *   - One element if passed something like "<div>...</div>"
    *   - Array of elements if passed "<a>...</a><a>...</a>"
    */
   #htmlToDom(html) {
      // Only the embed pages load jQuery.
      let children;
      if (window.jQuery?.parseHTML) {
         children = window.jQuery.parseHTML(html);
      } else {
         const container = document.createElement('div');
         container.innerHTML = html;
         children = [...container.children];
      }

      // If there is only one child, return that element instead of the array.
      return children.length === 1 ? children[0] : children;
   }

   /**
    * Returns a function(data, asString) that takes in an object and
    * produces some DOM elements (or a string if asString is set).
    */
   get(str) {
      if (!this.cachedTemplates[str]) {
         this.cachedTemplates[str] = this.#getCompiledTemplate(str);
      }
      return this.cachedTemplates[str];
   }
}

const templateInstance = new Template();
export default templateInstance;
